import React from "react";
import "./Company.css";

const Company = () => {
  return (
    <div className="company-page">

      {/* Company Section */}
      <section className="company-section">
        <div className="company-container">

          {/* Left Content */}
          <div className="company-text">
            <h1>About Our Company</h1>
            <p>
              InfraMart Solutions LLC is a premier provider of cutting-edge IT
              solutions and integrated technology services, delivering excellence
              across both federal and private sector markets. With a strong
              commitment to innovation, quality, and customer satisfaction, we
              empower businesses and government entities with next-generation
              technology infrastructure and customized solutions.
            </p>

            <h2>Company Overview</h2>
            <p>
              InfraMart Solutions LLC specializes in high-performance IT hardware,
              software solutions, and modern office furniture designed to enhance
              operational efficiency and drive digital transformation. We proudly
              serve government agencies, commercial enterprises, and institutional
              clients with reliable and scalable solutions.
            </p>

            <p>
               InfraMart Solutions LLC is a trusted federal
              procurement partner, ensuring seamless access to top-tier technology
              products and services.
            </p>

            <h2>Our Expertise</h2>
            <p>
              • IT Hardware & Software Solutions<br />
              • Government Contracting & GSA Procurement Services<br />
              • Enterprise IT Infrastructure, Cloud & Cybersecurity<br />
              • Office & Workspace Furniture Solutions
            </p>

            <h2>Strategic Partnerships</h2>
            <p>
              InfraMart Solutions LLC collaborates with key federal procurement
              programs including <strong>NASA SEWP</strong> and <strong>SPETA</strong>,
              enabling us to deliver innovative, compliant, and mission-critical
              IT solutions for government agencies.
            </p>

            <h2>Why Choose InfraMart Solutions LLC?</h2>
            <p>
              • Government-Approved GSA Vendor<br />
              • Industry-Leading Technology Partnerships<br />
              • Customer-Centric & Customized Solutions<br />
              • Proven Track Record in Federal & Commercial Markets
            </p>

            <p>
              At InfraMart Solutions LLC, we remain dedicated to driving digital
              transformation, operational efficiency, and security in today’s
              evolving IT landscape.
            </p>
          </div>

        </div>
      </section>

    </div>
  );
};

export default Company;
